import React from 'react';

const MadeForEveryoneSection = () => {
  return (
    <section>
      <div className="container">
        <h2 className="mt-4">Made for Everyone</h2>
        <p className="text-center1">
          Bitejoy Chocolates are crafted for kids, adults, fitness lovers, and
          families who want guilt-free indulgence without compromising on taste.
        </p>

        <div className="grids">
          <div className="cards">👧 Kids</div>
          <div className="cards">👨‍👩‍👧 Families</div>
          <div className="cards">💪 Fitness Lovers</div>
          <div className="cards">🧑 Chocolate Lovers</div>
        </div>
      </div>
    </section>
  );
};

export default MadeForEveryoneSection;
